// Set up console filtering FIRST, before anything else
// Ignore MetaMask, browser extension errors, WebSocket errors, worker errors, and library warnings
const isExtensionError = (msg) => {
  if (!msg) return false;
  const str = String(msg).toLowerCase();
  return str.includes('metamask') ||
    str.includes('chrome-extension') ||
    str.includes('moz-extension') ||
    str.includes('inpage.js') ||
    str.includes('wss://pg') ||
    str.includes('wss://') ||
    str.includes('ws://localhost') ||
    str.includes('ws://') ||
    str.includes('websocket') ||
    str.includes('rsocket') ||
    str.includes('worker was terminated') ||
    str.includes('defaultprops') ||
    str.includes('react-step-wizard');
};

// Store original console methods BEFORE any imports
const originalConsole = {
  error: console.error,
  warn: console.warn,
  log: console.log,
  debug: console.debug
};

// Override console methods immediately to catch rsocket and other library errors
['error', 'warn', 'log', 'debug'].forEach(method => {
  console[method] = (...args) => {
    const shouldFilter = args.some(arg => {
      if (typeof arg === 'string') {
        return isExtensionError(arg);
      } else if (typeof arg === 'object' && arg !== null) {
        try {
          const checks = [
            arg.message,
            arg.toString ? arg.toString() : '',
            arg.stack
          ];
          return checks.some(str => str && isExtensionError(String(str)));
        } catch (e) {
          return false;
        }
      }
      return false;
    });

    if (!shouldFilter) {
      originalConsole[method].apply(console, args);
    }
  };
});

// Add Array.prototype.at polyfill
if(!Array.prototype.at) {
  Array.prototype.at = function(index) {
    if(index < 0) {
      index = this.length+index;
    }
    if(index >= 0 && index < this.length) {
      return this[index];
    }
    return undefined;
  };
}

window.addEventListener('error', (e) => {
  if (isExtensionError(e.message) || isExtensionError(e.filename)) {
    e.stopImmediatePropagation();
    e.preventDefault();
    return true;
  }
}, true);

window.addEventListener('unhandledrejection', (e) => {
  if (isExtensionError(e.reason?.message) || isExtensionError(e.reason?.stack) || isExtensionError(String(e.reason))) {
    e.stopImmediatePropagation();
    e.preventDefault();
    return true;
  }
}, true);

import React from 'react';
import * as ReactDOM from "react-dom/client";
//import ReactDOM from 'react-dom';
import "react-datetime/css/react-datetime.css";
require('./assets/scss/style.scss');
// Light / dark before the first render (the app's web view asks for dark).
require('./theme/colorScheme').initColorScheme();
const app = require('./settings').app;

// Load only the app being run. A plain require() of all three put the user /
// consumer apps' global CSS (navy mobile-sidebar .nav-link rules etc.) into
// the production main.css, where it restyled every staff page; the dev
// server only injects CSS for the modules that run, so localhost never
// showed it.
const loadApp = () => (app == "consumer" ? import('./consumerApp')
  : app == "user" ? import('./userApp')
  : import('./app'));

//const App = require('./App').default;
const root = ReactDOM.createRoot(document.getElementById("root"));
// The session token is held in memory and restored from the HttpOnly cookie
// via /refresh before the first render (utils/session). The consumer app is
// anonymous (CONSUMER_TOKEN) and does not need it.
const { ensureToken, purgeLegacyStorage } = require('./utils/session');
purgeLegacyStorage();
// Mail links (/l/<app route>?w=<web path>) opened in a browser: go to the
// web page instead of booting the app on /l/ (utils/mailLink).
if (!require('./utils/mailLink').handleMailLink()) {
  const boot = app == "consumer" ? Promise.resolve() : ensureToken();
  const appModule = loadApp();
  boot.finally(() => {
    appModule.then(({ default: App }) => {
      root.render( <React.StrictMode> <App /> </React.StrictMode>);
    });
  });
}
